import { useEffect, useState, type ReactNode } from 'react'
import { AuthContext } from './authContext'
import { setUnauthorizedHandler } from './authedFetch'

export function AuthProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<User | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)

  useEffect(() => {
    setUnauthorizedHandler(() => setUser(null))
    const checkAuth = async () => {
      try {
        const res = await fetch('/api/auth/whoami', { credentials: 'include' })
        if (res.ok) {
          const data = await res.json()
          if (data.id !== null) {
            setUser(data)
          }
        } else if (res.status >= 500) {
          setError(true)
        }
      } catch {
        setError(true)
      }
      setLoading(false)
    }
    checkAuth()
    return () => setUnauthorizedHandler(() => {})
  }, [])

  return (
    <AuthContext.Provider value={{ user, loading, error }}>
      {children}
    </AuthContext.Provider>
  )
}
